import { getServerApi } from '@/gql';
import user from '@/stores/user';
import { useState } from 'react';

export interface UseMemoryAvailableResult {
    memoryAvailable: boolean | null;
    loading: boolean;
    error: Error | null;
    getMemoryAvailable: () => Promise<boolean | null>;
}

export const useMemoryAvailable = (
    tokenId: number,
): UseMemoryAvailableResult => {
    const [memoryAvailable, setMemoryAvailable] = useState<boolean | null>(
        null,
    );
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);
    const { userId } = user;

    const getMemoryAvailable = async () => {
        if (!tokenId || !userId) {
            setMemoryAvailable(null);
            return null;
        }
        try {
            setLoading(true);
            setError(null);
            const api = getServerApi();
            const response = await api.memoryAvailable({
                tokenId: tokenId,
            });
            if (response?.memoryAvailable !== undefined) {
                setMemoryAvailable(response.memoryAvailable);
                return response.memoryAvailable;
            } else {
                setMemoryAvailable(null);
                return null;
            }
        } catch (err) {
            console.error('Failed to fetch memory available:', err);
            setError(
                err instanceof Error
                    ? err
                    : new Error('Failed to fetch memory available'),
            );
            setMemoryAvailable(null);
            return null;
        } finally {
            setLoading(false);
        }
    };

    return {
        memoryAvailable,
        loading,
        error,
        getMemoryAvailable,
    };
};
